var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLmiRoute
      && this.$store.state.app.leftPanel
      && this.$store.state.lmi2015.leftPanel)?_c('search-panel'):_vm._e(),(_vm.isLmiRoute
      && this.$store.state.app.rightPanel
      && this.$store.state.lmi2015.rightPanel)?_c('info-panel'):_vm._e(),_c('Map'),_c('lmi2015-album-dates'),_c('lmi2015-album-sections'),_c('lmi2015-album-photo-gallery')],1)}
var staticRenderFns = []

export { render, staticRenderFns }